import { pageViewTypes } from "@constants/tracking";
import ModulesContainer from "@features/dashboard/screens/ModulesContainer";
import { isWeb } from "@helpers/platform";
import useAnalytics from "@hooks/useAnalytics";
import { useDemoExamStore } from "@hooks/useDemoExamStore";
import { useDevice } from "@hooks/useDevice";
import DocumentTitle from "components/DocumentTitle";
import { CustomAppbar } from "components/index";
import { useTranslation } from "react-i18next";

const ModulesRoute = () => {
	const { t } = useTranslation();
	const { isMobile } = useDevice();
	const demoExamId = useDemoExamStore((state) => state.currentExam.id);
	const isProethica = demoExamId === "proethica";

	useAnalytics({
		type: pageViewTypes.modules,
	});

	const headerTitle = isProethica ? "Learn" : t("navbar.modules");
	const headerSubtitle =
		isMobile || isProethica ? "" : t("appbar.modules.description");

	return (
		<>
			<CustomAppbar
				showHambugerMenu
				showCommandBar={isWeb}
				options={{
					headerTitle,
					subtitle: headerSubtitle,
				}}
			/>
			<DocumentTitle title={headerTitle} />
			<ModulesContainer />
		</>
	);
};

export default ModulesRoute;
